import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  ComboPropConfig,
  DataPropConfig,
  getValidations,
  InputType,
  isCompareInput,
  isRangeInput,
} from 'dg-input-lib';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { InputDataModel } from 'dg-dynamic-grid-lib';

import { AppGenServiceService } from '../service/app-gen-service.service';
import { data } from 'jquery';
import { I } from '@angular/cdk/keycodes';
import { Value } from '../../reason-for-disposing/reason-for-disposing.component';
import { HttpClient } from '@angular/common/http';
import { CommonService } from '../service/common.service';
import { Attribute } from '@angular/compiler';
import { map, startWith } from 'rxjs/operators';
import { CommonComponent } from '../common/common.component';
import { AppGenTabComponent } from '../app-gen-tab/app-gen-tab.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ExecutionService } from '../service/execution.service';
import { DatePipe } from '@angular/common';
import {
  StepperSelectionEvent,
  STEPPER_GLOBAL_OPTIONS,
  StepperOrientation,
} from '@angular/cdk/stepper';
import { NEW_CONFIG } from 'ngx-mask';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';

interface ComboModel {
  id?: string | number;
  optionText: string;
  optionValue: string | number;
  optionDesc?: string;
  isRange?: boolean;
  optionDisabled?: boolean;
  optionIcon?: string;
}

@Component({
  selector: 'app-app-gen-stepper',
  templateUrl: './app-gen-stepper.component.html',
  styleUrls: ['./app-gen-stepper.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
})
export class AppGenStepperComponent implements OnInit {
  inputDataPropConfig: DataPropConfig = {
    idProp: 'fieldId',
    typeProp: 'fieldType',
    nameProp: 'label',
    placeholderProp: 'placeholder',
    requiredProp: 'isMandatory',
    comboProp: 'comboMapValues',
    validationsProp: 'validations',
    disabledProp: 'enableDisable',
    minLengthProp: 'minLength',
    maxLengthProp: 'maxLength',
    hintProp: 'matHint',
  };

  comboPropConfig: ComboPropConfig = {
    labelProp: 'optionText',
    valueProp: 'optionValue',
    rangeProp: 'isRange',
    disabledProp: 'optionDisabled',
    iconProp: 'optionIcon',
  };

  @Input() res: any;
  @Input() FORMID: string = '304';

  @Input() stepData: any;
  @Input() attribute: any;

  @Input() eventId: any;
  formGroup: any = {};

  @ViewChild(CommonComponent) appCommon: CommonComponent;
  @ViewChild(AppGenStepperComponent)
  appGenStepperComponent: AppGenStepperComponent;
  @ViewChild(AppGenTabComponent) appGenTabComponent: AppGenTabComponent;

  showLabel = true;
  tabButton: any;
  getDataFromRouting: boolean;
  tid: any;
  @Input() caseRow;
  @Input() caseViewData: any;
  stepButton: any;
  tabLength: any;
  // isEditable = false;
  stepperOrientation: Observable<StepperOrientation>;

  constructor(
    private router: Router,
    private http: HttpClient,
    public commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private appGenServiceService: AppGenServiceService,
    private execution: ExecutionService,
    public datePipe: DatePipe,
    breakpointObserver: BreakpointObserver
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit(): void {
    //-------For Tab Button--start

    if (this.stepData.length < 1) {
      this.tabButton = false;
    }
    this.buttonControl(this.stepData);
    this.attribute.selectedIndex = 0;
  }

  buttonControl(stepData) {
    this.tabLength = stepData.filter((object) => {
      return object.attribute['hideShow'] == true;
    });
    // console.log("show length >",this.tabLength.length );
    if (this.stepData.length - this.tabLength.length < 2) {
      this.commonService.nextTab = true;
    } else {
      this.commonService.nextTab = false;
    }
  }

  onInputChange = (data, eventName) => {
    // Application Developer's code ;-)
    console.log('event change = ', data);
    if (data?.fieldType == 0) {
      let tempDate = this.commonService.appGenFormGroup.controls[data.fieldId]
        .value;
      if (tempDate != null) {
        tempDate = this.datePipe.transform(new Date(tempDate), 'yyyy-MM-dd');
        this.commonService.appGenFormGroup.controls[data.fieldId].setValue(
          tempDate
        );

        // For date valildation
        data?.attribute?.validations?.forEach((comp) => {
          this.commonService.dateValidation(
            comp.validationId,
            comp.cmpFormId,
            comp.otherCmpFormId,
            data,
            true
          );
        });
      }
    }
    // console.log('form validity: ', data, this.appGenStepperFormGroup);
    this.appGenServiceService.setAppGenData(
      data.fieldId,
      this.commonService.appGenFormGroup.controls[data.fieldId].value
    );

    data?.cmnFormFieldEventList?.forEach((event) => {
      if (event.eventName == eventName) {
        this.commonService.findcomboStringObj(this.stepData, data);
        this.execution.executeEventService(
          event.cmnEventExecutionList,
          this.commonService.appGenFormGroup,
          data,
          null,
          this.tid,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
      }
    });
  };

  getStepControl(mainFormGroup: FormGroup, stepConfig): FormGroup {
    console.log('step config for step ccotnrol', stepConfig);
    let stepControl = new FormGroup({});
    stepConfig.children?.forEach((childEle) => {
      stepControl.addControl(
        childEle?.fieldId,
        mainFormGroup.controls?.[childEle?.fieldId]
      );
      // stepControl.addControl(childEle?.fieldId,new FormControl(null,Validators.required));
    });

    return stepControl;
  }

  selectedStepChange(event: StepperSelectionEvent, data) {
    //console.log(event);
    //console.log(data);

    this.buttonControl(data);
    this.attribute.selectedIndex = event.selectedIndex;

    let tabFieldId = null;

    if (
      this.stepData.length - this.tabLength.length ==
      this.attribute.selectedIndex
    ) {
      this.commonService.nextTab = true;
    } else if (
      this.stepData.length - 1 - this.tabLength.length ==
      this.attribute.selectedIndex
    ) {
      this.commonService.nextTab = true;
      // console.log(this.attribute.selectedIndex);
      // console.log(this.tabLength.length);
    } else if (this.attribute.selectedIndex + 1 == this.stepData.length) {
      this.commonService.nextTab = true;
    } else {
      this.commonService.nextTab = false;
    }
  }
  onKeyPress(event) {
    return this.commonService.hashRestrict(event);
  }
}
